module.exports = __webpack_public_path__ + "img/police_car_light.ec5e7eed.gif";